module.exports = __webpack_public_path__ + "static/media/orcHiding.988932fa.png";